import { render, staticRenderFns } from "./MspForsageProfile.vue?vue&type=template&id=c8c408ca&scoped=true"
import script from "./MspForsageProfile.vue?vue&type=script&lang=js"
export * from "./MspForsageProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8c408ca",
  null
  
)

export default component.exports